export default {
  nav: {
    product: '产品',
    solutions: '解决方案',
    terminals: '三端协同',
    cases: '客户案例',
    pricing: '价格',
    contact: '联系销售',
    admin: '运营端入口',
    client: '客户端入口',
    pda: 'PDA 下载'
  },
  hero: {
    badge: '跨境物流全链路数字化',
    title: '让全球货物流转',
    titleHighlight: '像本地一样清晰',
    subtitle: '积米 JMTMS 是面向跨境物流企业的 TMS + WMS 一体化 SaaS 平台。从客户下单、仓库收货、海运订舱到尾程派送与财务结算，端到端数据贯通，三端实时协同。',
    ctaPrimary: '预约演示',
    ctaSecondary: '查看功能',
    stats: {
      efficiency: '订单处理效率提升',
      efficiencyValue: '60%',
      accuracy: '货箱数据准确率',
      accuracyValue: '98%',
      coverage: '业务节点覆盖',
      coverageValue: '8+'
    }
  },
  product: {
    eyebrow: '产品能力',
    title: '一套系统，打通运输与仓储',
    subtitle: '不再让 TMS 与 WMS 各自为政。JMTMS 把运单、货箱、库存、配载、财务编织成同一张网络。',
    modules: {
      customer: {
        title: '客户与渠道',
        desc: '直客 / 同行分级管理，SKU 产品库，认证资料，API 对接，开户效率提升 80%。'
      },
      waybill: {
        title: '业务单据',
        desc: '运单全生命周期，AI OCR 识别，55+ 维度筛选，20+ 自动校验规则。'
      },
      execution: {
        title: '物运执行',
        desc: '船期查询、代理比价、智能配载、装柜跟踪，配载到装柜周期缩短 30%。'
      },
      warehouse: {
        title: '仓储 WMS',
        desc: '仓库 / 库区 / 库位可视化，收货过机，实时库存，库龄预警，库位利用率提升 20%。'
      },
      finance: {
        title: '财务结算',
        desc: '运单审计锁定，应收 / 成本 / 提成三层审计，对账差错率降至接近 0。'
      },
      monitor: {
        title: '监控中心',
        desc: 'DW 送仓窗口监控，8 节点轨迹追踪，亚马逊考核自动预警。'
      }
    }
  },
  terminals: {
    eyebrow: '三端协同',
    title: '为每一种角色，提供趁手的终端',
    subtitle: '运营端、客户端、PDA 现场端数据实时同步，无论办公室、客户仓库还是码头，业务从不掉线。',
    admin: {
      tag: '运营端',
      title: '全局运营的驾驶舱',
      desc: '销售、客服、运营、财务在一个平台协作。客户管理、运单处理、订舱比价、配载调度、财务审计、监控预警，全部可视化。',
      cta: '进入运营端'
    },
    client: {
      tag: '客户端',
      title: '客户自助的门户',
      desc: '直客与同行货代可自助下单、查轨迹、对账单、维护产品库与地址库，7×24 小时掌握货物动态。',
      cta: '进入客户端'
    },
    pda: {
      tag: 'PDA 现场端',
      title: '仓库作业的掌中宝',
      desc: '收货、扫码拣货、装车确认、异常上报、库位管理，全流程移动端化，与运营端实时同步。',
      cta: 'Android 下载',
      scanTip: '扫码下载 PDA App'
    }
  },
  solutions: {
    eyebrow: '行业解决方案',
    title: '专为 FBA 与跨境专线设计',
    subtitle: '从亚马逊合规到智能配载，每个场景都经过真实业务打磨。',
    items: {
      amazon: {
        title: '亚马逊 FBA 合规',
        desc: '两次数据互联、DW 窗口自动监控、轨迹同步检查，自动满足亚马逊四大考核指标。'
      },
      consolidation: {
        title: '智能配载装柜',
        desc: '组合配载 / 散货配载双模式，装载率实时计算，≥95% 绿色高亮，空间利用最大化。'
      },
      visibility: {
        title: '全链路可视化',
        desc: '客户数据 / 拣货数据 / 修改后数据三列对比，货物状态一目了然。'
      },
      ecosystem: {
        title: '供应商互联',
        desc: '云当网、几何智造、墨家、亚马逊、货拉拉等第三方深度对接，数据自动回流。'
      }
    }
  },
  stats: {
    title: '数据驱动的跨境物流',
    subtitle: '每一次流程优化，都转化为可衡量的业务结果。',
    items: {
      efficiency: { value: '60%', label: '下单效率提升' },
      load: { value: '95%', label: '装载率绿色阈值' },
      inventory: { value: 'T+0', label: '库存数据实时性' },
      audit: { value: '3', label: '财务审计层级' }
    }
  },
  cta: {
    title: '开启跨境物流的新节奏',
    subtitle: '预约一次 30 分钟的产品演示，看看 JMTMS 如何让你的团队少加班、少出错、多赚钱。',
    primary: '预约演示',
    secondary: '联系销售'
  },
  footer: {
    slogan: '让全球货物流转像本地一样清晰',
    copyright: '© 2026 积米 JMTMS. 保留所有权利。',
    links: {
      product: '产品',
      solutions: '解决方案',
      docs: '开发文档',
      privacy: '隐私政策',
      terms: '服务条款'
    }
  },
  language: {
    zh: '中文',
    en: 'English'
  }
}
